import { FormattedMessage } from 'dibs-react-intl';
import { ConnectRow } from '../ConnectRow/ConnectRow';
import socialLinks from '../messages/socialLinks';
import { type FooterLink } from '../FooterLinkTypes';
import FooterSubscribeLazy from '../FooterSubscribe/FooterSubscribeLazy';

import dibsCss from 'dibs-css';

export const blog: FooterLink = {
    linkName: 'blog',
    trackingLabel: 'Blog',
    href: '/blogs/the-study/',
    dataTn: 'footer-blog',
    enablerKey: 'wpEditorialLink',
    message: (
        <span className={dibsCss.sassyFontSubHeaderTypeNormal}>
            <FormattedMessage id="dbl.Footer.site_links_blog" defaultMessage="The Study" />
        </span>
    ),
};

export const magazine: FooterLink = {
    linkName: 'magazine',
    trackingLabel: 'Magazine',
    href: '/introspective-magazine/',
    dataTn: 'footer-magazine',
    enablerKey: 'wpEditorialLink',
    message: (
        <FormattedMessage
            id="dbl.Footer.site_links_magazine"
            defaultMessage="<span>Introspective</span> Magazine"
            values={{
                span: content => (
                    <span className={dibsCss.sassyFontSubHeaderTypeNormal}>{content}</span>
                ),
            }}
        />
    ),
};

export const connectLinks: FooterLink[] = [
    {
        linkName: 'subscribe',
        CustomComponent: FooterSubscribeLazy,
        dataTn: 'footer-subscribe',
    },
    {
        linkName: 'connect',
        CustomComponent: ConnectRow,
        items: socialLinks,
        dataTn: 'connect-row',
    },
];
